module.exports = __webpack_public_path__ + "static/media/microsoft-teams-start.747b1baf.png";